import { render, staticRenderFns } from "./LeonidaPrenotazioneViewComponent.vue?vue&type=template&id=ca301b8a"
import script from "./LeonidaPrenotazioneViewComponent.vue?vue&type=script&lang=js"
export * from "./LeonidaPrenotazioneViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports